import { Card, CardContent, Skeleton, Box } from "@mui/material";
import TableSkeleton from "../../../../../../../components/BasicComponents/Skeletons/TableSkeleton";

export default function UltimasVendasSkeleton() {
    return (
        <Card>
            <CardContent>
                {/* Título */}
                <Skeleton 
                    variant="text" 
                    width="40%" 
                    height={32} 
                    sx={{ mb: 2 }}
                />

                {/* Tabela */}
                <TableSkeleton 
                    rows={5} 
                    columns={2} 
                    showHeader={true}
                    height={30}
                />

                {/* Total de registros */}
                <Box display="flex" justifyContent="flex-end" mt={1}>
                    <Skeleton 
                        variant="text" 
                        width={100} 
                        height={20}
                    />
                </Box>

                {/* Botão Ver Mais */}
                <Box display="flex" justifyContent="flex-end" mt={1}>
                    <Skeleton 
                        variant="rectangular" 
                        width={80} 
                        height={32}
                        sx={{ borderRadius: 1 }}
                    />
                </Box>
            </CardContent>
        </Card>
    );
}